<div class="card overflow-auto flex flex-col md:flex-row sm:mr-6">
  <div class="p-gutter flex-auto max-w-[400px]">
    <h4 class="font-bold">Aplicaciones</h4>

    <hr />

    <div class="mt-4 grid grid-cols-3">
      @for (app of apps; track app) {
        <a
          (click)="close(app)"
          class="text-dark p-3 text-center hover:bg-primary/10 hover:text-primary trans-ease-out rounded block no-underline hover:cursor-pointer"
          >
          <mat-icon [svgIcon]="app.icon" class="icon-xl primary-icon" color="primary"></mat-icon>
          <div class="body-2 mt-2">{{ app.label }}</div>
        </a>
      }
    </div>
  </div>
</div>
